module.exports = __webpack_public_path__ + "img/179.d833c1ed.svg";